import http from "./httpService";
import { uploadApi } from "./config.json";

export async function uploadPOFile(fd) {
  const { data } = await http.post(uploadApi + "uploadPO.php", fd);
  return data;
}
export async function uploadSCApprovalFile(fd) {
  const { data } = await http.post(uploadApi + "uploadSCApproval.php", fd);
  return data;
}

export async function uploadSupplierConfirmationFile(fd) {
  const { data } = await http.post(
    uploadApi + "uploadSupplierConfirmation.php",
    fd
  );
  return data;
}

export async function uploadConfirmationDocument(fd) {
  const { data } = await http.post(
    uploadApi + "uploadConfirmationDocument.php",
    fd
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/services/uploadServices.js